import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderBoComponent } from 'src/app/components/header-bo/header-bo.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    HeaderBoComponent
  ],
  exports: [
    HeaderBoComponent
  ]

})
export class CommonBoModuleModule { }
